import { useRef, useEffect, useCallback } from 'react';

const useEventCallback = (fn, deps) => {
  const ref = useRef(fn);
  useEffect(() => {
    ref.current = fn;
  }, [fn, ...deps]);
  return useCallback((...args) => {
    const callback = ref.current;
    callback(...args);
  }, [ref]);
};

export { useEventCallback };
